// extracted by mini-css-extract-plugin
export default {"banner_wrapper":"Banner_banner_wrapper__t2w6d","banner_text":"Banner_banner_text__wHks6"};